/* RHÔME — tiroir panier
   S'ouvre automatiquement après un ajout (événement cart:refresh),
   recalcule le sous-total, les frais de livraison estimés et le total. */
(function () {
  'use strict';

  var root, scrim, panel, body, countEls, barEl, shipEl, shipTxt,
      subEl, shipLineEl, grandEl, format, threshold, shipCost, freeMsg, awayMsg;

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') > -1) {
      return format
        .replace(/\{\{\s*amount\s*\}\}/, v)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
    }
    return v + ' dh';
  }

  function open() { if (panel) { panel.classList.add('is-on'); scrim.classList.add('is-on'); } }
  function close() { if (panel) { panel.classList.remove('is-on'); scrim.classList.remove('is-on'); } }
  function busy(on) { if (panel) panel.classList.toggle('is-busy', !!on); }

  function lineHtml(item, index) {
    var img = item.image
      ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')
      : '';
    var opts = '';
    if (item.options_with_values && item.options_with_values.length) {
      opts = item.options_with_values.map(function (o) { return o.name + ' : ' + o.value; }).join(' · ');
    }
    var price = '';
    if (item.original_line_price > item.final_line_price) {
      price = '<s>' + money(item.original_line_price) + '</s>' + money(item.final_line_price);
    } else {
      price = money(item.final_line_price);
    }
    return '' +
      '<div class="rh-cart__line">' +
        '<a href="' + item.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') + '</a>' +
        '<div>' +
          '<a class="rh-cart__nm" href="' + item.url + '">' + item.product_title + '</a>' +
          (opts ? '<div class="rh-cart__vr">' + opts + '</div>' : '') +
          '<div class="rh-cart__row">' +
            '<span class="rh-cart__qty">' +
              '<button type="button" data-rh-qty="' + index + '" data-to="' + (item.quantity - 1) + '" aria-label="Diminuer">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-rh-qty="' + index + '" data-to="' + (item.quantity + 1) + '" aria-label="Augmenter">+</button>' +
            '</span>' +
            '<span class="rh-cart__pr">' + price + '</span>' +
          '</div>' +
          '<button type="button" class="rh-cart__rm" data-rh-qty="' + index + '" data-to="0">Retirer</button>' +
        '</div>' +
      '</div>';
  }

  function render(cart) {
    if (!panel) return;

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (!cart.items.length) {
      body.innerHTML = '<div class="rh-cart__empty">' +
        '<svg viewBox="0 0 24 24"><path d="M6 7h12l1.4 13H4.6L6 7z"/><path d="M9 7V5.5a3 3 0 016 0V7"/></svg>' +
        'Votre panier est vide.</div>';
    } else {
      body.innerHTML = cart.items.map(lineHtml).join('');
    }

    var sub = cart.total_price;
    var free = sub >= threshold;
    var ship = (cart.items.length === 0) ? 0 : (free ? 0 : shipCost);

    if (shipEl) {
      shipEl.classList.toggle('is-free', free && cart.items.length > 0);
      if (cart.items.length === 0) {
        shipTxt.innerHTML = awayMsg.replace('{montant}', '<b>' + money(threshold) + '</b>');
      } else if (free) {
        shipTxt.innerHTML = freeMsg;
      } else {
        shipTxt.innerHTML = awayMsg.replace('{montant}', '<b>' + money(threshold - sub) + '</b>');
      }
      barEl.style.width = Math.min(100, (sub / threshold) * 100) + '%';
    }

    if (subEl) subEl.textContent = money(sub);
    if (shipLineEl) shipLineEl.textContent = (cart.items.length === 0) ? '—' : (free ? 'Offerte' : money(ship));
    if (grandEl) grandEl.textContent = money(sub + ship);

    bindLines();
  }

  function fetchCart(andOpen) {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        if (andOpen) open();
        return cart;
      });
  }

  function change(line, qty) {
    busy(true);
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); busy(false); })
      .catch(function () { busy(false); });
  }

  function bindLines() {
    body.querySelectorAll('[data-rh-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var line = parseInt(b.getAttribute('data-rh-qty'), 10) + 1;
        var to = parseInt(b.getAttribute('data-to'), 10);
        if (to < 0) return;
        change(line, to);
      });
    });
  }

  function init() {
    root = document.querySelector('[data-rh-cart]');
    if (!root) return;
    scrim = root.querySelector('[data-rh-cart-scrim]');
    panel = root.querySelector('[data-rh-cart-panel]');
    body = root.querySelector('[data-rh-cart-body]');
    barEl = root.querySelector('[data-rh-cart-bar]');
    shipEl = root.querySelector('[data-rh-cart-ship]');
    shipTxt = root.querySelector('[data-rh-cart-shiptxt]');
    subEl = root.querySelector('[data-rh-cart-sub]');
    shipLineEl = root.querySelector('[data-rh-cart-shipline]');
    grandEl = root.querySelector('[data-rh-cart-grand]');
    countEls = Array.prototype.slice.call(document.querySelectorAll('.rh-count'));

    format = root.getAttribute('data-money') || '';
    threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
    shipCost = parseInt(root.getAttribute('data-ship'), 10) || 0;
    freeMsg = root.getAttribute('data-free') || 'Livraison offerte';
    awayMsg = root.getAttribute('data-away') || 'Plus que {montant} pour la livraison offerte';

    root.querySelectorAll('[data-rh-cart-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* l'icône panier de l'en-tête ouvre le tiroir au lieu de changer de page */
    document.querySelectorAll('.rh-tools a[href*="/cart"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart(true);
      });
    });

    /* ouverture automatique après un ajout */
    document.addEventListener('cart:refresh', function () { fetchCart(true); });

    fetchCart(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
